import { render, staticRenderFns } from "./AtrasoJustificadoObligatorioModal.vue?vue&type=template&id=34c8ed02&scoped=true"
import script from "./AtrasoJustificadoObligatorioModal.vue?vue&type=script&lang=js"
export * from "./AtrasoJustificadoObligatorioModal.vue?vue&type=script&lang=js"
import style0 from "./AtrasoJustificadoObligatorioModal.vue?vue&type=style&index=0&id=34c8ed02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c8ed02",
  null
  
)

export default component.exports